<template lang="pug" src="./active-order.pug"> </template>
<style lang="scss" src="./active-order.scss" scoped> </style>

<script>
import { mapGetters, mapState } from 'vuex';
import copyToClipboard from '@/utils/copy';
import config from '../../../../../config.json';
import helpers from '@/utils/helpers';
import orderAddress from '@/views/pages/ReceiveOrders/order-address';
import infoOrder from '@/views/pages/ReceiveOrders/info-order';
import orderHistory from '@/views/pages/ReceiveOrders/order-history';
import debounce from "debounce";

export default {
    components: {
        'v-order-address': orderAddress,
        'v-info-order': infoOrder,
        'v-order-history': orderHistory
    },
    props: {
        activeOrderId: {
            type: Number,
            required: true
        },
        showOrderHistory: {
            type: Boolean
        }
    },
    data: () => ({
        isSearchAuto: false,
        isCalculateOrder: false,
        pooling: null,
        poolingLateTime: null,
        orderHistoryPolling: null,
        timer: '00:00',
        isShowCancelReasons: false,
        isShowOrderCancelDetails: false,
        cancelOrderDetails: {
            questionType: null,
            explanation: null,
            isResolved: false
        },
        isUpdatedPhoneNumber: false,
        preOrderInput: null,
        lateTime: '00:00',
        orderData: {
            brand: null,
            customerPhone: '',
            tariff: null,
            comment: '',
            tips: '',
            preOrderTime: null,
            reducedTariff: false
        },
        selectedDate: {
            value: 'now'
        },
        callSign: '',
        validDate: '',
        isCustomerPhoneDisabled: true,
        statusesFullDisabled: ['accepted', 'arrived', 'landed', 'completed', 'cancelled'],
        activeOrder: {
            status: 'new'
        },
        notLoadData: true,
        saveData: false,
        requestProcessing: false,
        canFocusHouse: true,
        tariffSearch: ''
    }),
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            brands: (state) => state.data.brands,
            tariffs(state) {
                if(!this.orderData.brand) return [];

                return state.data.brandOptions
                    && state.data.brandOptions[this.orderData.brand.id]
                    && state.data.brandOptions[this.orderData.brand.id].tariffs
                        .map(it => this.optionHandler(it));
            },
            options(state) {
                if(!this.orderData.brand) return [];

                return state.data.brandOptions
                    && state.data.brandOptions[this.orderData.brand.id]
                    && state.data.brandOptions[this.orderData.brand.id].options
                        .filter(it => !it.hidden);
            },
            orderHistories: (state) => state.orders.orderHistories,
            clientStatusesHistory: (state) => state.orders.clientStatusesHistory,
            orderDrivers: (state) => state.orders.orderDrivers,
            filteredOrderDrivers: (state) => state.orders.filteredOrderDrivers,
            brandDetails(state) {
                return state.orders.brandDetails
                    && state.orders.brandDetails[
                        this.orderData.brand && this.orderData.brand.id
                    ];
            },
            allOrders: (state) => state.orders.allOrders,
            coordinates: (state) => state.orders.coordinates,
            isShowHistory: (state) => state.orders.isShowHistory,
            addresses: (state) => state.orders.activeOrderAddresses
        }),
        cancelReasons() {
            if(this.activeOrder.isSos) {
                return [config.reasons.find(it => it.value === 'notSos')];
            } else {
                return config.reasons.filter({ use: true });
            }
        },
        questionsTypes() {
            const types = config.orderCancelDetails.questionsTypes;
            const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails.questionsList';

            return types.map(key => ({
                key,
                value: this.$vuetify.lang.t(`${translationPath}.${key}`)
            }));
        },
        explanationTypes() {
            const { isResolved, questionType } = this.cancelOrderDetails;
            const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails.explanationsList';

            const resolveText = isResolved ? 'resolved' : 'unresolved';
            const types = config.orderCancelDetails.explanation[resolveText];

            return types && types[questionType] && types[questionType].map(key => ({
                key,
                value: this.$vuetify.lang.t(`${translationPath}.${key}`)
            }));
        },
        orderDates() {
            return [{
                text: this.$vuetify.lang.t(`$vuetify.pages.ReceiveOrders.now`),
                value: 'now'
            }, {
                text: this.$vuetify.lang.t(`$vuetify.pages.ReceiveOrders.today`),
                value: 'today'
            }, {
                text: this.$vuetify.lang.t(`$vuetify.pages.ReceiveOrders.tomorrow`),
                value: 'tomorrow'
            }];
        },
        isValidTime: function() {
            if (this.selectedDate.value === 'today' && this.isValidDate(this.getPreOrderTime())) {
                const validTime =  Date.create(new Date()).addMinutes(config.minPreOrderTime);
                return this.getPreOrderTime() < new Date(validTime);
            } else if (this.selectedDate.value === 'now') {
                return false;
            }
            else {
                return this.isValidDate(this.getPreOrderTime()) ? false : true;
            }
        },
        time: function() {
            if(!this.selectedDate.value) return null;
            return Date.create(new Date()).addMinutes(config.minPreOrderTime + 1);
        },
        isSearching: function() {
            return this.activeOrder.status === 'searching';
        },
        isPreAssign: function() {
            return this.activeOrder.status == 'searching' && this.activeOrder.isPreAssign;
        },
        price: function() {
            return this.orderData.price;
        },
        canCalculateRoute: function() {
            return !this.isEdit && this.orderData.tariff
                && this.brandDetails && this.brandDetails.calculateRoute
                && this.addresses.length > 1
                && this.addresses.every(it => it.latitude && it.longitude)
                && !this.orderData.price;
        },
        iShowPrice: function() {
            return this.orderData.price && this.addresses.length > 1;
        },
        canStartSearch: function() {
            const isFilled = this.addresses.every(it => it.street || it.osmId);

            return !this.isValidTime && this.orderData.tariff
                && this.addresses && this.addresses[0]
                && !this.canCalculateRoute && isFilled && this.activeOrder.status !== 'arrived';
        },
        canSaveData: function() {
            return ['waiting', 'new'].includes(this.activeOrder.status) && this.canStartSearch;
        },
        canRecalculateRoute: function() {
            const statuses = ['accepted', 'arrived'];

            return this.orderData.price && this.isSearch
                && !statuses.includes(this.activeOrder.status) && this.addresses.length > 1;
        },
        canStartWait: function() {
            const notAllowedStatuses = ['accepted', 'waiting', 'arrived'];
            return !this.isPreAssign && !notAllowedStatuses.includes(this.activeOrder.status);
        },
        isDisableField: function() {
            return this.isSearching && this.isPreAssign || this.activeOrder.status === 'arrived';
        },
        isCorporate: function() {
            const roles = ['corporate-admin', 'corporate-user'];

            return roles.includes(
                this.activeOrder.client
                && this.activeOrder.client.user
                && this.activeOrder.client.user.roleName
            );
        },
        isDeliveryTime() {
            return !this.activeOrder.isLate && this.activeOrder.deliveryTime && this.activeOrder.status === 'accepted';
        },
        isLateTime() {
            return this.activeOrder.isLate && this.activeOrder.status === 'accepted';
        },
        isSearch() {
            return this.canStartSearch && !this.isPreAssign
                && this.activeOrder.status != 'accepted';
        },
        isEdit() {
            return this.isSearching && this.isPreAssign && !this.activeOrder.isSos;
        },
        isShowBonus() {
            return this.activeOrder.bonusUseLimit
                && this.activeOrder.bonusUseLimit.isActive
                && new Date(this.activeOrder.bonusUseLimit.endDate) > new Date();
        },
        countOrdersForBonus() {
            const countOrdersForBonus = this.activeOrder.countOrdersForBonus;

            return countOrdersForBonus < 0 ? false : countOrdersForBonus;
        },
        isShowForced() {
            return config.forcedAppointment && this.isSearching && this.isPreAssign;
        },
        disabledSetUnactive() {
            return !this.activeOrder.isSos && this.activeOrder.status === 'searching' && !this.canStartSearch;
        },
        showIncreaseTariff() {
            const tariffIncrease = config.tariffIncrease;

            if (!tariffIncrease.show) {
                return false;
            }

            return tariffIncrease.time.some(it => {
                const fromDate = new Date();
                const toDate = new Date();

                fromDate.setMinutes(it.from.minutes || 0);
                fromDate.setHours(it.from.hours);
                fromDate.setSeconds(0);

                toDate.setMinutes(it.to.minutes || 0);
                toDate.setHours(it.to.hours);
                toDate.setSeconds(0);

                return new Date(fromDate) < new Date() && new Date(toDate) > new Date();
            });
        }
    },
    watch: {
        tariffSearch: debounce(function(newValue, oldValue) {
            if (typeof newValue != 'string' || !!(newValue && !oldValue)) {
                return;
            }

            this.$store.dispatch('data/getDriverCommissionSystems', {
                query: newValue || ''
            });
        }, 500),
    },
    created: async function() {
        await this.$store.dispatch('data/getOptions');
        this.$store.dispatch('orders/getOrderData', this.activeOrderId).then(data => {
            if (data) {
                this.activeOrder = Object.assign({}, data, {
                    orderOptions: data.orderOptions.map(it => this.optionHandler(it))
                });
                this.notLoadData = false;

                this.initOrderWindow();
            }
        });
    },
    mounted: function() {
        window.addEventListener('keydown', this.keydownHandler);
    },
    beforeDestroy: function() {
        window.removeEventListener('keydown', this.keydownHandler);

        this.$store.commit('data/CLEAR_BRAND_OPTIONS');
        this.$store.commit('orders/SET_ACTIVE_ORDER_ADDRESSES', [{}]);
        this.resetMarkers();

        clearInterval(this.pooling);
        clearInterval(this.orderHistoryPolling);
        clearInterval(this.poolingLateTime);
    },
    methods: {
        updateOrderHistory: function() {
            this.orderHistoryPolling = setInterval(() => {
                this.$store.dispatch('orders/getAllOrders', this.activeOrder.id);
            }, config.orderHistoryInterval);
        },

        optionHandler: function(data) {
            if (data.levels && data.levels[0]) {
                return Object.assign(data, { optionName: data.levels[0].optionName });
            }

            return data;
        },

        initOrderWindow: function() {
            this.$store.dispatch('orders/getAllOrders', this.activeOrder.id);
            this.setActiveOptions();
            if (this.isSearching) {
                this.$store.dispatch('orders/getOrderDrivers', this.activeOrder.id);
            }
            this.setPreOrderTime();
            this.pooling = setInterval(() => {
                this.timer = helpers.initControllTimer(this.activeOrder.createdAt);
            }, 1000);

            this.pollingLateTime = setInterval(() => {
                this.lateTime = helpers.initControllTimer(this.activeOrder.arrivalTime);
            }, 1000);
            this.updateOrderHistory();
        },

        addressesArr: function() {
            const addresses = this.activeOrder.addresses;

            return (addresses && addresses.length) ? addresses : [{}];
        },

        editCustomerPhone: function() {
            this.isCustomerPhoneDisabled = false;
            this.canFocusHouse = false;
            this.$nextTick(() => {
                this.$refs.customerPhone.focus();
            });
        },

        onCustomerPhoneChange() {
            this.updateOrders({ reloadBonuses: true }).then(data => {
                if (data && data.client && data.clientId != this.activeOrder.clientId) {
                    this.activeOrder.client = Object.assign({}, data.client);
                    this.activeOrder.clientId = data.clientId;
                    this.activeOrder.previousTariff = data.previousTariff;
                }

                this.setBonusData(data);
            });

            this.isUpdatedPhoneNumber = true;
        },

        setBonusData(data) {
            if (data && typeof data === "object") {
                this.activeOrder = Object.assign({}, this.activeOrder, {
                    bonusUseLimit: data.bonusUseLimit,
                    isBonusOrder: data.isBonusOrder,
                    countOrdersForBonus: data.countOrdersForBonus,
                    bonusBalance: data.bonusBalance
                });
            }
        },

        isToday(date) {
            return date ? new Date().getDate() == new Date(date).getDate() : null;
        },

        getOrderData() {
            return {
                id: this.activeOrder.id,
                brandId: this.orderData.brand.id,
                chosenOption: this.orderData.tariff && this.orderData.tariff.id,
                options: this.options.filter(it => it.checked),
                comment: this.orderData.comment,
                tips: this.orderData.tips,
                preOrderTime: this.orderData.preOrderTime,
                addresses: this.addresses,
                phoneNumber: this.orderData.customerPhone,
                reducedTariff: this.orderData.reducedTariff
            };
        },

        setActiveDate() {
            const activeDate = this.activeOrder.preOrderTime;
            if (this.isToday(activeDate)) {
                this.selectedDate.value = 'today';
            } else if (activeDate) {
                this.selectedDate.value = 'tomorrow';
            } else {
                this.selectedDate.value = 'now';
                return null;
            }
            return this.formatDate(activeDate);
        },

        formatDate(date) {
            const minutes = new Date(date).getMinutes() < 10 ? '0' + new Date(date).getMinutes() : new Date(date).getMinutes();
            const hours = new Date(date).getHours() < 10 ? '0' + new Date(date).getHours() : new Date(date).getHours();
            return `${hours}:${minutes}`;
        },

        setActiveOptions() {
            this.$store.commit('orders/SET_ACTIVE_ORDER_ADDRESSES', this.addressesArr());

            this.preOrderInput = this.setActiveDate();
            this.orderData.tips = this.activeOrder.tips;
            this.orderData.reducedTariff = this.activeOrder.reducedTariff || false;
            this.orderData.customerPhone = this.activeOrder.client && this.activeOrder.client.user && this.activeOrder.client.user.phoneNumber || config.defaultTaxiNumber;
            this.orderData.brand = this.activeOrder.brand;
            this.orderData.comment = this.activeOrder.comment;

            const defaultOption = this.activeOrder.orderOptions && this.activeOrder.orderOptions.find(it => it.defaultOptions);
            this.orderData.tariff = defaultOption || this.tariffs.find(it => it.id === this.activeOrder.brand.defaultOptionId);

            this.options.forEach((option) => {
                const checkedOption = this.activeOrder.orderOptions && this.activeOrder.orderOptions.find(it => it.id === option.id);
                if (checkedOption) {
                    option.checked = true;
                }
            });
        },

        disableCustomerPhone() {
            this.canFocusHouse = true;
            this.isCustomerPhoneDisabled = true;
        },

        async setOrderToWait() {
            if(this.activeOrder.status === 'searching' && this.canStartSearch) {
                this.searchOrder();
            } else {
                await this.$store.dispatch('orders/setOrderToWait', this.activeOrder.id)
                    .then(this.onDisactiveOrder);
            }
        },

        resetPriceAndDistance() {
            if (this.orderData.price) {
                this.$set(this.orderData, 'price', null);
                this.$set(this.orderData, 'distanceMeters', null);
            }
        },

        onTariffChange() {
            this.resetPriceAndDistance();
        },

        changeAddress() {
            this.resetMarkers();
            this.resetPriceAndDistance();
        },

        onTipsChange(tips) {
            this.orderData.tips = tips || null;
        },

        onBrandChange: async function(brand) {
            this.$store.dispatch('orders/getBrandDetails', brand.id);
            this.$store.commit('data/CLEAR_BRAND_OPTIONS');
            this.orderData.brand = brand;

            this.$nextTick(() => {
                const defaultTariff = this.tariffs.find(it => it.id === brand.defaultOptionId);

                this.orderData.tariff = defaultTariff || this.tariffs[0];
            });

            this.updateOrders({ reloadBonuses: true }).then(data => {
                this.setBonusData(data);
            });
        },

        onDateChange(date) {
            this.selectedDate = date;
            this.setPreOrderTime();

            this.$nextTick(() => {
                if (this.$refs.timePicker) {
                    this.$refs.timePicker.focus();
                }
            });
        },

        addAddressBlock() {
            this.$store.commit('orders/ADD_ACTIVE_ORDER_ADDRESS');

            if (this.orderData.price) {
                this.orderData.price = null;
            }
        },

        isValidDate(d) {
            return d instanceof Date && !isNaN(d);
        },

        async waitOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.updateOrder().then(() => {
                return this.$store.dispatch('orders/waitOrder', this.activeOrder.id);
            }).then(this.onDisactiveOrder).finally(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },

        onOptionChange() {
            if (this.orderData.price) {
                this.$set(this.orderData, 'price', null);
                this.$set(this.orderData, 'distanceMeters', null);
            }
        },

        toggleIsShowCancelReasons() {
            this.isShowCancelReasons = !this.isShowCancelReasons;
        },

        onQuestionTypeChange(questionType) {
            this.cancelOrderDetails.explanation = null;
            this.cancelOrderDetails.questionType = questionType;
        },

        onResolvedChange(isResolved) {
            this.cancelOrderDetails.explanation = null;
            this.cancelOrderDetails.isResolved = !!isResolved;
        },

        closeOrderCancelDetails() {
            this.isShowOrderCancelDetails = false;

            this.cancelOrderDetails = {
                questionType: null,
                explanation: null,
                isResolved: false
            };
        },

        onCancelReasonClick(reason) {
            if (reason == 'not-order') {
                this.isShowCancelReasons = false;
                this.isShowOrderCancelDetails = true;
                return;
            }

            this.cancelOrder(reason);
        },

        onCallSignChange(callSign) {
            this.$store.commit('orders/SET_FILTERED_ORDER_DRIVERS', this.orderDrivers.filter(it => it.callSign.match(callSign)));
        },

        getPreOrderTime() {
            if (!this.preOrderInput) {
                const today = new Date().toLocaleDateString();
                return new Date(today);
            }

            const date = Date.create(this.preOrderInput);
            let preOrderTime = Date.create(this.preOrderInput);
            preOrderTime.setHours(date.getHours());
            preOrderTime.setMinutes(date.getMinutes());
            return new Date(preOrderTime.toString());
        },

        setPreOrderTime() {
            if (this.selectedDate.value === 'tomorrow' && this.isValidDate(this.getPreOrderTime())) {
                this.orderData.preOrderTime = new Date(this.getPreOrderTime().setDate(this.getPreOrderTime().getDate() + 1));
            } else if (this.selectedDate.value === 'today') {
                this.orderData.preOrderTime = this.getPreOrderTime();
            } else {
                this.orderData.preOrderTime = null;
                return null;
            }
        },

        async updateOrders(props) {
            const reloadBonuses = props && props.reloadBonuses;
            const data = Object.assign({}, this.getOrderData(), { reloadBonuses });

            return await this.$store.dispatch('orders/updateOrder', data);
        },

        async updateOrder() {
            return await this.$store.dispatch('orders/updateOrder', this.getOrderData());
        },

        onDisactiveOrder(res) {
            if (res) {
                this.$emit('onDisactiveOrder', this.activeOrderId);
            }
        },

        onActiveOrder(res) {
            if (res) {
                this.$emit('onActiveOrder', this.activeOrderId);
            }
        },

        searchOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/searchOrder', this.getOrderData())
                .then(this.onDisactiveOrder)
                .finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        saveOrderData() {
            if (this.saveData) {
                return;
            }

            this.saveData = true;

            this.updateOrder().then(data => {
                if (data) {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }

                setTimeout(() => {
                    this.saveData = false;
                }, 2000);
            });
        },

        calculateOrder() {
            this.closeHistory();

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/getCoordinates', this.getOrderData()).then(data => {
                if (data && data.order) {
                    this.$set(this.orderData, 'price', data.order.calculatedPrice);
                    this.$set(this.orderData, 'distanceMeters', data.order.distanceMeters);

                    this.$nextTick(() => {
                        this.$refs.container.scrollTo({ top: 1000, behavior: 'smooth' });
                    });
                }
            }).finally(() => {
                this.$nextTick(() => {
                   this.requestProcessing = false;
                });
            });
        },

        async cancelOrder(cancelReason, id = this.activeOrder.id) {
            if (this.requestProcessing) return;
            this.requestProcessing = true;

            const requestPayload = { id, cancelReason };
            if (cancelReason == 'not-order') {
                Object.assign(requestPayload, {
                    ...this.cancelOrderDetails
                });
            }

            await this.$store.dispatch('orders/cancelOrder', requestPayload)
                .then(this.onDisactiveOrder)
                .finally(() => this.$nextTick(() => {
                    this.requestProcessing = false;
                }));
        },

        forceOrder(driverId) {
            this.$store.dispatch('orders/forcedOrder', {
                orderId: this.activeOrder.id,
                driverId
            });
        },

        editOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/editOrder', {orderId: this.activeOrder.id}).then(res => {
                if (res && this.activeOrder.status === 'searching') {
                    this.activeOrder.isPreAssign = false;
                }
            }).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },

        async saveOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('orders/saveOrder', this.getOrderData())
                .then(this.onDisactiveOrder)
                .finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        onEnterPress(index) {
            const activeComment = document.querySelectorAll('.input input:not([type="hidden"])')[index + 1];

            if (activeComment) {
                activeComment.focus();
            }
        },

        keydownHandler(event) {
            if (event.repeat) { return; }

            if (this.isShowCancelReasons) {
                const keys = this.cancelReasons.map((it, index) => 49 + index);

                if (event.altKey && keys.includes(event.which)) {
                    event.preventDefault();
                    this.cancelOrder(this.cancelReasons[event.which - 49].key);
                    return;
                }
            }
            if (this.isSearch) {
                if(event.ctrlKey && event.keyCode === 13) {
                    this.searchOrder();
                    return;
                }
            }
            if (this.isEdit) {
                if(event.ctrlKey && event.keyCode === 13) {
                    this.editOrder();
                    return;
                }
            }
            if (this.canCalculateRoute) {
                if(event.ctrlKey && event.keyCode === 13) {
                    this.calculateOrder();
                    return;
                }
            }
            if (this.isEdit) {
                if(event.ctrlKey && event.keyCode === 13) {
                    this.editOrder();
                    return;
                }
            }
            if (event.keyCode === 27) {
                this.setOrderToWait();
                return;
            }
            if (this.canStartWait || ['waiting', 'accepted'].includes(this.activeOrder.status)) {
                if (event.keyCode === 45) {
                    this.addAddressBlock();
                    return;
                }
            }
            if (!this.activeOrder.isSos) {
                if (event.ctrlKey && event.altKey) {
                    this.duplicateOrder();
                }
            }
        },

        async replaceOrder(order) {
            await this.cancelOrder('not-order', this.activeOrder.id);
            await this.$store.dispatch('orders/makeActiveOrder', order.id);
            await this.$store.dispatch('orders/getAllOrders', this.activeOrder.id);
        },

        deleteAddress(event, index) {
            this.$store.commit('orders/REMOVE_ACTIVE_ORDER_ADDRESS', index);

            if (this.addresses.length < 2) {
                this.resetMarkers();
            }

            if (this.orderData.price) {
                this.orderData.price = null;
            }
        },

        duplicateOrder() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('orders/duplicateOrder', {
                id: this.activeOrderId
            }).then(() => {
                this.$store.dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'duplicate'
                }, { root: true });
            }).finally(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },

        isValidAddress(index) {
            return this.coordinates.length && !this.coordinates[index];
        },

        closeHistory() {
            if (this.isShowHistory){
                this.$store.commit('orders/SET_IS_SHOW_HISTORY', false);
            }
        },

        resetMarkers() {
            this.$store.commit('orders/SET_COORDINATES', []);
            this.$store.commit('orders/SET_POLYLINE', []);
            this.$store.commit('orders/CLEAR_ADDRESS_COORDS');
        },

        copyToClipboard
    }
};
</script>
